<template>
  <vs-tabs>
    <vs-tab label="Customer">
      <Customer/>
    </vs-tab>
    <vs-tab label="Distribution Channel">
      <DistributionChannel/>
    </vs-tab>
    <vs-tab label="Distribution Channel SKU">
      <DistributionChannelSKU/>
    </vs-tab>
  </vs-tabs>
</template>
<script>
import Customer from "./customer.vue";
import DistributionChannel from "./distribution-channel.vue";
import DistributionChannelSKU from "./distribution-channel-sku.vue";

export default {
  components: {
    Customer,
    DistributionChannel,
    DistributionChannelSKU,
  },
  data() {
    return {
    };
  },
};
</script>